const REGION_ALIASES = [
  ["beijing", "\u5317\u4eac\u5e02", "\u5317\u4eac"],
  ["tianjin", "\u5929\u6d25\u5e02", "\u5929\u6d25"],
  ["hebei", "\u6cb3\u5317\u7701", "\u6cb3\u5317"],
  ["shanxi", "\u5c71\u897f\u7701", "\u5c71\u897f"],
  ["inner-mongolia", "\u5185\u8499\u53e4\u81ea\u6cbb\u533a", "\u5185\u8499\u53e4"],
  ["liaoning", "\u8fbd\u5b81\u7701", "\u8fbd\u5b81"],
  ["jilin", "\u5409\u6797\u7701", "\u5409\u6797"],
  ["heilongjiang", "\u9ed1\u9f99\u6c5f\u7701", "\u9ed1\u9f99\u6c5f"],
  ["shanghai", "\u4e0a\u6d77\u5e02", "\u4e0a\u6d77"],
  ["jiangsu", "\u6c5f\u82cf\u7701", "\u6c5f\u82cf"],
  ["zhejiang", "\u6d59\u6c5f\u7701", "\u6d59\u6c5f"],
  ["anhui", "\u5b89\u5fbd\u7701", "\u5b89\u5fbd"],
  ["fujian", "\u798f\u5efa\u7701", "\u798f\u5efa"],
  ["jiangxi", "\u6c5f\u897f\u7701", "\u6c5f\u897f"],
  ["shandong", "\u5c71\u4e1c\u7701", "\u5c71\u4e1c"],
  ["henan", "\u6cb3\u5357\u7701", "\u6cb3\u5357"],
  ["hubei", "\u6e56\u5317\u7701", "\u6e56\u5317"],
  ["hunan", "\u6e56\u5357\u7701", "\u6e56\u5357"],
  ["guangdong", "\u5e7f\u4e1c\u7701", "\u5e7f\u4e1c"],
  ["guangxi", "\u5e7f\u897f\u58ee\u65cf\u81ea\u6cbb\u533a", "\u5e7f\u897f"],
  ["hainan", "\u6d77\u5357\u7701", "\u6d77\u5357"],
  ["chongqing", "\u91cd\u5e86\u5e02", "\u91cd\u5e86"],
  ["sichuan", "\u56db\u5ddd\u7701", "\u56db\u5ddd"],
  ["guizhou", "\u8d35\u5dde\u7701", "\u8d35\u5dde"],
  ["yunnan", "\u4e91\u5357\u7701", "\u4e91\u5357"],
  ["tibet", "\u897f\u85cf\u81ea\u6cbb\u533a", "\u897f\u85cf"],
  ["shaanxi", "\u9655\u897f\u7701", "\u9655\u897f"],
  ["gansu", "\u7518\u8083\u7701", "\u7518\u8083"],
  ["qinghai", "\u9752\u6d77\u7701", "\u9752\u6d77"],
  ["ningxia", "\u5b81\u590f\u56de\u65cf\u81ea\u6cbb\u533a", "\u5b81\u590f"],
  ["xinjiang", "\u65b0\u7586\u7ef4\u543e\u5c14\u81ea\u6cbb\u533a", "\u65b0\u7586"],
];

const REGION_NAMES = REGION_ALIASES.flatMap(([, full, short]) => [full, short]);
const DIRECT_REGION_LABELS = REGION_ALIASES.filter(([, full]) => full.endsWith("市"))
  .flatMap(([, full, short]) => [full, short]);
const INDUSTRY_TERMS = [
  "农、林、牧、渔业",
  "采矿业",
  "制造业",
  "建筑业",
  "批发和零售业",
  "交通运输",
  "仓储",
  "物流",
  "住宿和餐饮业",
  "信息技术服务",
  "软件",
  "互联网",
  "金融业",
  "房地产业",
  "物业",
  "租赁和商务服务业",
  "商务服务",
  "企业管理服务",
  "法律服务",
  "会计",
  "审计",
  "税务服务",
  "人力资源服务",
  "知识产权服务",
  "咨询与调查",
  "咨询",
  "广告业",
  "会议",
  "展览",
  "办公服务",
  "科学研究和技术服务业",
  "教育",
  "卫生和社会工作",
  "文化、体育和娱乐业",
];
const INDUSTRY_ALIAS_GROUPS = [
  ["金融业", "银行业", "银行", "保险业", "保险", "证券业", "证券", "基金", "期货"],
  ["交通运输", "交通运输业", "仓储", "物流", "运输", "出租汽车行业", "出租汽车", "船员", "海员", "海事"],
  ["租赁和商务服务业", "商务服务", "企业管理服务", "法律服务", "会计", "审计", "税务服务", "人力资源服务", "知识产权服务", "咨询与调查", "咨询", "广告业", "会议", "展览", "办公服务"],
  ["信息技术服务", "软件", "互联网", "信息技术", "软件开发", "前端", "后端", "架构工程师", "开发人员", "程序员", "著作权"],
  ["制造业", "生产制造", "工厂", "设备"],
  ["建筑业", "建筑施工", "施工"],
  ["房地产业", "物业", "物业管理", "物业服务"],
  ["教育", "学校", "培训机构"],
  ["卫生和社会工作", "医疗", "医院", "医护"],
  ["住宿和餐饮业", "住宿", "餐饮"],
];
const INDUSTRY_MATCH_TERMS = unique([...INDUSTRY_TERMS, ...INDUSTRY_ALIAS_GROUPS.flat()]);
const BUSINESS_SCOPE_GROUPS = [
  {
    fileTerms: ["劳务派遣", "派遣合规", "派遣比例", "派遣单位", "派遣员工", "派遣制", "员工租赁"],
    allowTerms: ["劳务派遣", "派遣服务", "人力资源服务"],
    reason: "其他业务类型",
  },
  {
    fileTerms: ["事业单位"],
    allowTerms: ["事业单位", "机关事业"],
    reason: "其他业务类型",
  },
  {
    fileTerms: ["交通协管员"],
    allowTerms: ["交通协管", "交通运输", "城市管理", "公共管理"],
    reason: "其他行业",
  },
  {
    fileTerms: ["体育赛事"],
    allowTerms: ["体育", "赛事", "文化、体育和娱乐"],
    reason: "其他行业",
  },
  {
    fileTerms: ["律师事务所", "实习律师", "兼职律师", "刑事律师", "派驻律师"],
    allowTerms: ["律师事务所", "法律服务", "律师"],
    reason: "其他行业",
  },
  {
    fileTerms: ["司机", "驾驶员", "汽车租赁", "车辆租赁", "出租汽车", "货物", "仓库租赁", "运输", "物流", "船员", "海员", "航空器", "二手车", "借车"],
    allowTerms: ["交通运输", "物流", "运输", "仓储", "出租汽车", "船员", "海员", "海事", "航空", "司机", "驾驶员", "汽车"],
    reason: "其他行业",
  },
  {
    fileTerms: ["建筑工人", "建筑施工", "建筑垃圾", "建设工程", "工程劳务", "工程施工", "工地"],
    allowTerms: ["建筑", "施工", "建设工程"],
    reason: "其他行业",
  },
  {
    fileTerms: ["房地产", "房屋租赁", "住宅租赁", "房产", "物业", "车位", "储藏室", "公租房", "宅基地", "商铺", "公寓", "收房", "勾地", "土地一级开发", "房屋管理", "墓地", "房屋建筑物", "构筑物", "国有土地", "土地使用权", "土地承包", "土地联合", "在建房屋", "学区房屋", "房屋", "拆迁", "开发商", "卖房", "房屋过户"],
    allowTerms: ["房地产", "房产", "物业", "不动产", "商业地产", "公寓"],
    reason: "其他行业",
  },
  {
    fileTerms: ["酒店", "餐饮", "餐厨", "婚宴", "客房", "食堂"],
    allowTerms: ["住宿", "餐饮", "酒店", "食堂"],
    reason: "其他行业",
  },
  {
    fileTerms: ["教师", "学校", "教育培训", "培训机构", "瑜伽", "瑜珈", "上门授课", "家教"],
    allowTerms: ["教育", "学校", "培训机构", "瑜伽", "瑜珈", "家教"],
    reason: "其他行业",
  },
  {
    fileTerms: ["保安", "保洁", "家政", "保镖"],
    allowTerms: ["保安", "保洁", "家政", "物业服务", "居民服务"],
    reason: "其他行业",
  },
  {
    fileTerms: ["银行", "证券", "基金", "期货", "信托", "融资租赁", "保险金融"],
    allowTerms: ["金融", "银行", "证券", "基金", "期货", "信托", "融资租赁", "保险"],
    reason: "其他行业",
  },
  {
    fileTerms: ["医院", "医师", "护士", "医护", "医疗服务", "临床研究", "临床试验", "体检服务", "治疗服务", "宠物手术", "宠物危重", "助浴", "月子", "养老"],
    allowTerms: ["医疗", "医院", "卫生", "医护", "养老", "宠物"],
    reason: "其他行业",
  },
  {
    fileTerms: ["制造", "生产技术", "工厂", "矿山", "钻头", "委托生产", "委托加工", "印刷", "物资租赁", "仪器校准", "空调", "电子屏幕"],
    allowTerms: ["制造", "生产制造", "工厂", "采矿", "矿山", "印刷", "设备"],
    reason: "其他行业",
  },
  {
    fileTerms: ["农产品", "农村土地", "农业", "动物实验"],
    allowTerms: ["农、林、牧、渔业", "农业", "农产品", "动物实验"],
    reason: "其他行业",
  },
  {
    fileTerms: ["博物馆", "文物", "图书出版", "剧本", "影视", "音乐著作权", "音像著作权", "司仪", "婚庆", "啤酒音乐节", "体育场馆", "NFT", "电影", "摄影", "摄像", "新闻信息", "转载", "专栏作家", "文学艺术", "音乐产品"],
    allowTerms: ["文化、体育和娱乐业", "文化", "体育", "娱乐", "影视", "出版"],
    reason: "其他行业",
  },
  {
    fileTerms: ["空气检测", "空气污染", "水质处理", "消毒灭菌", "灭火器", "室内环境", "室内空气", "中央空调", "弱电系统", "灯光设计", "大型雕塑", "山林看护", "土地清查", "搬运服务"],
    allowTerms: ["环保", "环境", "消防", "物业", "工程", "建筑", "设备", "广告"],
    reason: "其他行业",
  },
  {
    fileTerms: ["线下零售商", "实物商品", "提货单", "收货单", "分销", "经销", "进口服务", "清关", "报关", "药店", "门店", "商场", "店铺", "4S店", "充电宝"],
    allowTerms: ["批发", "零售", "贸易", "销售", "采购", "电商", "商品", "制造", "生产", "供应链", "进出口"],
    reason: "其他行业",
  },
  {
    fileTerms: ["导游", "商旅", "机票", "滑雪", "游学", "户外活动"],
    allowTerms: ["旅游", "商旅", "教育", "文化、体育和娱乐业", "体育"],
    reason: "其他行业",
  },
  {
    fileTerms: ["买卖合同纠纷", "购销合同纠纷", "货款纠纷"],
    allowTerms: ["批发", "零售", "贸易", "销售", "采购", "电商", "商品", "制造", "生产", "供应链"],
    reason: "其他行业",
  },
  {
    fileTerms: ["借款合同", "担保服务合同", "保证担保书", "地产公司员工借款", "融资服务"],
    allowTerms: ["金融", "银行", "投资", "融资", "担保", "租赁", "地产"],
    reason: "其他行业",
  },
  {
    fileTerms: ["限制性股权", "股权激励", "股权转让", "增资协议", "并购协议"],
    allowTerms: ["投资", "股权", "金融", "基金", "并购", "资产管理"],
    reason: "其他行业",
  },
  {
    fileTerms: ["婚姻家庭", "婚姻", "离婚", "家庭直接雇佣"],
    allowTerms: ["婚姻", "家事"],
    reason: "其他业务类型",
  },
];
const COMMERCIAL_EXCHANGE_SCOPE_GROUPS = [
  {
    submoduleKeys: ["lease"],
    submoduleNames: ["租赁"],
    fileTerms: ["租赁"],
    allowTerms: ["租赁", "房地产", "物业", "不动产", "交通运输", "仓储", "物流", "汽车", "设备", "融资租赁"],
    reason: "其他行业",
  },
  {
    submoduleKeys: ["sale-purchase"],
    submoduleNames: ["买卖购销"],
    fileTerms: ["买卖", "购销", "采购", "销售"],
    allowTerms: ["批发", "零售", "贸易", "销售", "采购", "电商", "商品", "制造", "生产", "供应链"],
    reason: "其他行业",
  },
  {
    submoduleKeys: ["loan-guarantee"],
    submoduleNames: ["借贷担保"],
    fileTerms: ["借款", "担保", "融资", "质押", "抵押"],
    allowTerms: ["金融", "银行", "投资", "融资", "担保", "租赁"],
    reason: "其他行业",
  },
  {
    submoduleKeys: ["investment-equity"],
    submoduleNames: ["投资股权"],
    fileTerms: ["股权", "投资", "增资", "并购", "收购"],
    allowTerms: ["投资", "股权", "金融", "基金", "并购", "资产管理"],
    reason: "其他行业",
  },
  {
    submoduleKeys: ["gift-exchange"],
    submoduleNames: ["赠与交换"],
    fileTerms: ["赠与", "交换"],
    allowTerms: ["公益", "慈善", "个人", "家事"],
    reason: "其他业务类型",
  },
];
const NATIONAL_TERMS = [
  "全国",
  "国家",
  "中华人民共和国",
  "劳动法",
  "劳动合同法",
  "民法典",
  "个人所得税法",
];
const GENERAL_TERMS = [
  "通用",
  "标准",
  "默认",
  "基础",
];
const SOURCE_LAYERS = {
  company: { rank: 100, reason: "公司专用", layer: "company", badges: ["公司专用"] },
  personal: { rank: 90, reason: "个人常用", layer: "personal", badges: ["个人常用"] },
};
const GUANGDONG_LOCAL_NAMES = [
  "\u5e7f\u5dde",
  "\u6df1\u5733",
  "\u73e0\u6d77",
  "\u6c55\u5934",
  "\u4f5b\u5c71",
  "\u97f6\u5173",
  "\u6e5b\u6c5f",
  "\u8087\u5e86",
  "\u6c5f\u95e8",
  "\u8302\u540d",
  "\u60e0\u5dde",
  "\u6885\u5dde",
  "\u6c55\u5c3e",
  "\u6cb3\u6e90",
  "\u9633\u6c5f",
  "\u6e05\u8fdc",
  "\u4e1c\u839e",
  "\u4e2d\u5c71",
  "\u6f6e\u5dde",
  "\u63ed\u9633",
  "\u4e91\u6d6e",
];

const REGION_LOCAL_NAMES = {
  guangdong: GUANGDONG_LOCAL_NAMES,
};

// 底座和后端返回的企业字段不完全一致，这里按优先级提取最可能包含地区的信息。
function firstText(...values) {
  return values
    .flatMap((value) => {
      if (!value) return [];
      if (typeof value === "object") return Object.values(value);
      return [value];
    })
    .map((value) => String(value || "").trim())
    .find(Boolean) || "";
}

function allText(...values) {
  return unique(
    values.flatMap((value) => {
      if (!value) return [];
      if (typeof value === "object") return Object.values(value);
      return [value];
    }),
  ).join(" ");
}

function fileSearchText(file) {
  return [
    file.fileName,
    file.displayName,
    file.templateName,
    file.submoduleName,
    file.scenarioName,
    file.templateSource,
    file.previewText,
    file.snippet,
  ]
    .filter(Boolean)
    .join(" ");
}

function fileTitleText(file) {
  return [
    file.fileName,
    file.displayName,
    file.templateName,
    file.templateSource,
  ]
    .filter(Boolean)
    .join(" ");
}

function fileScopeText(file) {
  return [
    file.fileName,
    file.displayName,
    file.templateName,
    file.submoduleName,
    file.scenarioName,
    file.templateSource,
  ]
    .filter(Boolean)
    .join(" ");
}

function localEditionSegments(text) {
  // 识别“仙桃市2022版”“深圳市2018版”等地方版模板，避免外地城市模板被当成通用模板。
  return Array.from(text.matchAll(/[（(]([^（）()]{2,32}?(?:省|市|县|区|州|盟)[^（）()]{0,18}?(?:19|20)\d{2}\s*版)[）)]/g))
    .map((match) => match[1]);
}

function localNameSegments(text) {
  // 先识别完整省市区片段，并兼容广州、东营等两个字的城市名。
  return Array.from(text.matchAll(/([\u4e00-\u9fa5]{2,16}市(?:[\u4e00-\u9fa5]{2,12}(?:区|县))?|[\u4e00-\u9fa5]{2,12}(?:省|区|县|州|盟))/gu))
    .map((match) => match[1])
    .filter((value) => !["有限公司", "责任公司", "股份公司"].some((suffix) => value.endsWith(suffix)));
}

function districtMentions(segment) {
  return Array.from(String(segment || "").matchAll(/([\u4e00-\u9fa5]{2,12}(?:区|县))/gu))
    .map((match) => match[1])
    .filter((value) => !value.endsWith("自治区"));
}

function mentionsOtherDistrict(segment, region) {
  const currentLabels = [
    region.districtName,
    region.districtShortName,
    region.shortName,
  ].filter(Boolean);
  if (!currentLabels.length) return false;
  return districtMentions(segment).some(
    (mention) => !currentLabels.some((label) => mention.includes(label) || label.includes(mention)),
  );
}

function segmentMatchesRegion(segment, region) {
  if (mentionsOtherDistrict(segment, region)) return false;
  // 同省不等于同市，省名不能把其他城市的专用合同放行。
  const cities = Array.from(segment.matchAll(/([\u4e00-\u9fa5]{2,12}市)/gu), (match) => match[1]);
  if (region.cityName && cities.length && !cities.some((city) => city.includes(region.cityName))) return false;
  const labels = [
    region.fullName,
    region.provinceName,
    region.provinceShortName,
    region.cityName,
    region.cityShortName,
    region.districtName,
    region.districtShortName,
    region.shortName,
  ].filter(Boolean);
  if (labels.some((label) => segment.includes(label))) return true;
  return !region.cityName && (REGION_LOCAL_NAMES[region.key] || []).some((name) => segment.includes(name));
}

function segmentRegionRank(segment, region) {
  if (!segmentMatchesRegion(segment, region)) return 0;
  if (
    [region.fullName, region.districtName, region.districtShortName]
      .filter(Boolean)
      .some((label) => segment.includes(label))
  ) return 80;
  if (
    [region.cityName, region.cityShortName]
      .filter(Boolean)
      .some((label) => segment.includes(label))
  ) return 70;
  if (
    [region.provinceName, region.provinceShortName, region.name]
      .filter(Boolean)
      .some((label) => segment.includes(label))
  ) return DIRECT_REGION_LABELS.includes(region.provinceName) ? 70 : 60;
  return 60;
}

function shortLocalName(value) {
  return String(value || "")
    .replace(/特别行政区$/u, "")
    .replace(/维吾尔自治区$/u, "")
    .replace(/壮族自治区$/u, "")
    .replace(/回族自治区$/u, "")
    .replace(/自治区$/u, "")
    .replace(/[省市区县]$/u, "");
}

function unique(values) {
  return Array.from(new Set(values.map((value) => String(value || "").trim()).filter(Boolean)));
}

function extractCityName(source, provinceFullName, provinceShortName) {
  const withoutProvince = source
    .replace(provinceFullName || "", "")
    .replace(provinceShortName || "", "");
  const match = withoutProvince.match(/([\u4e00-\u9fa5]{2,12}市)/u);
  return match?.[1] || "";
}

function extractDistrictName(source, cityName, provinceFullName, provinceShortName) {
  const districtSource = cityName && source.includes(cityName)
    ? source.slice(source.indexOf(cityName) + cityName.length)
    : source
        .replace(provinceFullName || "", "")
        .replace(provinceShortName || "", "");
  const match = districtSource.match(/([\u4e00-\u9fa5]{2,12}(?:区|县))/u);
  return match?.[1] || "";
}

function resolveIndustryLabels(industrySource) {
  const source = String(industrySource || "").trim();
  if (!source) return [];
  const labels = INDUSTRY_MATCH_TERMS.filter((term) => source.includes(term) || term.includes(source));
  const aliasLabels = INDUSTRY_ALIAS_GROUPS
    .filter((group) => group.some((term) => source.includes(term) || term.includes(source)))
    .flat();
  if (/商务服务|企业管理服务|咨询|办公服务|人力资源服务/u.test(source)) {
    labels.push(
      "租赁和商务服务业",
      "企业管理服务",
      "商务服务",
      "咨询与调查",
      "咨询",
      "人力资源服务",
      "办公服务",
      "广告业",
      "会议",
      "展览",
    );
  }
  return unique([source, ...labels, ...aliasLabels]);
}

function sourceRank(file) {
  if (file.kind === "company" || file.templateType === "company") return 100;
  if (file.kind === "personal" || file.templateType === "personal") return 90;
  return 0;
}

function sourceLayer(file) {
  if (file.kind === "company" || file.templateType === "company") return SOURCE_LAYERS.company;
  if (file.kind === "personal" || file.templateType === "personal") return SOURCE_LAYERS.personal;
  return null;
}

function stringList(value) {
  if (!value) return [];
  if (Array.isArray(value)) return unique(value);
  return unique(String(value).split(/[、,，;；|]/u));
}

function bestRegionRank(labels, region) {
  if (!region?.key || !labels.length) return 0;
  return Math.max(...labels.map((label) => segmentRegionRank(label, region)));
}

function regionReason(rank) {
  if (rank >= 80) return "区县适用";
  if (rank >= 70) return "城市适用";
  if (rank >= 60) return "省级适用";
  return "通用模板";
}

function regionLayer(rank) {
  if (rank >= 80) return "district";
  if (rank >= 70) return "city";
  if (rank >= 60) return "province";
  return "general";
}

function industryMatches(labels, region) {
  if (!labels.length || !region?.industryLabels?.length) return true;
  return labels.some((term) =>
    region.industryLabels.some((label) => sameIndustryFamily(term, label)),
  );
}

function sameIndustryFamily(term, label) {
  if (term.includes(label) || label.includes(term)) return true;
  return INDUSTRY_ALIAS_GROUPS.some((group) =>
    group.some((value) => term.includes(value) || value.includes(term))
    && group.some((value) => label.includes(value) || value.includes(label)),
  );
}

function industryTermsInText(text) {
  return INDUSTRY_MATCH_TERMS.filter((term) => text.includes(term));
}

function businessScopeMismatch(file, region) {
  const text = fileScopeText(file);
  const contextText = [
    region?.contextSource,
    region?.source,
    region?.industrySource,
  ]
    .filter(Boolean)
    .join(" ");
  const matchedGroup = BUSINESS_SCOPE_GROUPS.find((group) =>
    group.fileTerms.some((term) => text.includes(term)),
  );
  if (!matchedGroup) return null;
  if (matchedGroup.allowTerms.some((term) => contextText.includes(term))) return null;
  return { visible: false, rank: 0, reason: matchedGroup.reason, layer: "hidden", badges: [] };
}

function textMatchesAny(text, terms) {
  return terms.some((term) => text.includes(term));
}

function contextMatchesAny(region, terms) {
  const contextText = [
    region?.contextSource,
    region?.source,
    region?.industrySource,
    ...(region?.industryLabels || []),
  ]
    .filter(Boolean)
    .join(" ");
  return textMatchesAny(contextText, terms);
}

function commercialExchangeMismatch(file, region) {
  if (file.moduleKey !== "commercial-exchange" && file.moduleName !== "商业往来") return null;
  if (!region?.industryLabels?.length && !region?.industrySource) return null;

  const text = fileScopeText(file);
  const submoduleKey = String(file.submoduleKey || "");
  const submoduleName = String(file.submoduleName || "");
  const matchedGroup = COMMERCIAL_EXCHANGE_SCOPE_GROUPS.find((group) =>
    group.submoduleKeys.some((key) => submoduleKey === key)
    || group.submoduleNames.some((name) => submoduleName === name)
    || textMatchesAny(text, group.fileTerms),
  );
  if (!matchedGroup) return null;
  if (contextMatchesAny(region, matchedGroup.allowTerms)) return null;
  return { visible: false, rank: 0, reason: matchedGroup.reason, layer: "hidden", badges: [] };
}

function structuredApplicability(file) {
  const value = file.applicability;
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const regions = stringList(value.regions);
  const industries = stringList(value.industries);
  const excludeRegions = stringList(value.excludeRegions);
  const excludeIndustries = stringList(value.excludeIndustries);
  const scope = String(value.scope || "").trim();
  if (
    !scope
    && !regions.length
    && !industries.length
    && !excludeRegions.length
    && !excludeIndustries.length
    && value.isGeneral !== true
  ) {
    return null;
  }
  return {
    scope,
    regions,
    industries,
    excludeRegions,
    excludeIndustries,
    isGeneral: value.isGeneral === true,
  };
}

function structuredEvaluation(file, region) {
  const applicability = structuredApplicability(file);
  if (!applicability) return null;

  // 结构化适用范围来自模板元数据，优先级高于文件名里的地区、行业关键词推断。
  if (bestRegionRank(applicability.excludeRegions, region)) {
    return { visible: false, rank: 0, reason: "其他地区", layer: "hidden", badges: [] };
  }
  if (!industryMatches(applicability.excludeIndustries, region)) {
    return { visible: false, rank: 0, reason: "其他行业", layer: "hidden", badges: [] };
  }

  const regionRank = bestRegionRank(applicability.regions, region);
  if (applicability.regions.length && !regionRank) {
    return { visible: false, rank: 0, reason: "其他地区", layer: "hidden", badges: [] };
  }

  if (applicability.industries.length && !industryMatches(applicability.industries, region)) {
    return { visible: false, rank: 0, reason: "其他行业", layer: "hidden", badges: [] };
  }

  if (regionRank) {
    return {
      visible: true,
      rank: regionRank,
      reason: regionReason(regionRank),
      layer: regionLayer(regionRank),
      badges: applicability.regions,
    };
  }

  if (applicability.industries.length || applicability.scope === "industry") {
    return {
      visible: true,
      rank: 40,
      reason: "行业适用",
      layer: "industry",
      badges: applicability.industries.length ? applicability.industries : ["行业适用"],
    };
  }

  if (applicability.scope === "national") {
    return { visible: true, rank: 30, reason: "全国通用", layer: "national", badges: ["全国"] };
  }

  if (applicability.isGeneral || applicability.scope === "general") {
    return { visible: true, rank: 20, reason: "通用模板", layer: "general", badges: ["通用"] };
  }

  return { visible: true, rank: 20, reason: "通用模板", layer: "general", badges: ["通用"] };
}

function nationalEvaluation(text) {
  if (!NATIONAL_TERMS.some((term) => text.includes(term))) return null;
  return { visible: true, rank: 30, reason: "全国通用", layer: "national", badges: ["全国"] };
}

function generalEvaluation(text) {
  if (!GENERAL_TERMS.some((term) => text.includes(term))) {
    return { visible: true, rank: 20, reason: "通用模板", layer: "general", badges: ["通用"] };
  }
  return { visible: true, rank: 20, reason: "通用模板", layer: "general", badges: ["通用"] };
}

function locationCandidates(profile) {
  if (!profile || typeof profile !== "object") return [];
  return [
    profile.city || profile.district || profile.county
      ? allText(profile.province, profile.city, profile.district, profile.county).replaceAll(" ", "")
      : "",
    allText(profile.region, profile.companyRegion),
    profile.registeredAddress,
    profile.companyAddress,
    profile.address,
    profile.businessAddress,
    profile.officeAddress,
    profile.location,
    profile.area,
    profile.province,
  ].map((value) => allText(value)).filter(Boolean);
}

function recognizeLocation(source, allowUnknownCity = true) {
  let match = REGION_ALIASES.find(([, full, short]) => source.includes(full) || source.includes(short));
  // 使用已有城市归属表补全省份；未收录城市仍保留城市精确匹配，不猜测其省份。
  if (!match) {
    const provinceKey = Object.keys(REGION_LOCAL_NAMES).find((key) =>
      REGION_LOCAL_NAMES[key].some((city) => source.includes(`${city}市`) || source === city),
    );
    match = REGION_ALIASES.find(([key]) => key === provinceKey);
  }
  const cityName = extractCityName(source, match?.[1], match?.[2]);
  if (!match && (!cityName || !allowUnknownCity)) return null;
  const districtName = extractDistrictName(source, cityName, match?.[1], match?.[2]);
  return { source, match, cityName, districtName };
}

export function resolveCompanyRegion(company, foundationContext) {
  // 认证上下文是当前企业快照，不能用上次请求留下的公司地址或行业补齐新企业。
  const hasFoundationCompany = Boolean(foundationContext?.companyProfile || foundationContext?.company
    || foundationContext?.tenant || foundationContext?.companyName);
  const profiles = hasFoundationCompany
    ? [foundationContext.companyProfile, foundationContext.company, foundationContext.tenant,
      { companyName: foundationContext.companyName }]
    : [company?.profile, company];
  const candidates = profiles.flatMap(locationCandidates);
  const names = profiles.flatMap((profile) => [profile?.name, profile?.companyName]).filter(Boolean);
  // 非空编码或简称不应截断地址回退；名称仅在没有可用地区资料时兜底。
  const locations = candidates.map((value) => recognizeLocation(String(value)))
    .concat(names.map((value) => recognizeLocation(String(value), false))).filter(Boolean);
  const location = locations.reduce((current, candidate) => {
    if (!current) return candidate;
    if (current.match && candidate.match && current.match[0] !== candidate.match[0]) return current;
    if (current.cityName && candidate.cityName !== current.cityName) return current;
    if (current.districtName && candidate.districtName !== current.districtName) return current;
    // 省级资料允许同地区的登记地址补齐市区，但后面的字段不能改变已确认的地区。
    const specificity = (value) => Number(Boolean(value.cityName)) + Number(Boolean(value.districtName));
    return specificity(candidate) > specificity(current)
      ? { ...candidate, match: current.match || candidate.match }
      : current;
  }, null);
  const source = location?.source || firstText(...candidates, ...names);
  const industrySource = firstText(...profiles.flatMap((profile) =>
    [profile?.industryType, profile?.companyIndustry, profile?.industry],
  ));
  const contextSource = allText(source, industrySource, ...profiles);
  const scopeRequired = Boolean(company || foundationContext);
  const match = location?.match;
  if (!location) {
    return {
      source,
      contextSource,
      key: "",
      name: "",
      fullName: "",
      shortName: "",
      provinceName: "",
      provinceShortName: "",
      cityName: "",
      cityShortName: "",
      districtName: "",
      districtShortName: "",
      industrySource,
      industryLabels: resolveIndustryLabels(industrySource),
      scopeRequired,
    };
  }
  const { cityName, districtName } = location;
  const fullName = [match?.[1], cityName, districtName].filter(Boolean).join("");
  return {
    source,
    contextSource,
    key: match?.[0] || "",
    name: match?.[1] || cityName,
    fullName,
    shortName: districtName ? shortLocalName(districtName) : cityName ? shortLocalName(cityName) : match?.[2] || "",
    provinceName: match?.[1] || "",
    provinceShortName: match?.[2] || "",
    cityName,
    cityShortName: shortLocalName(cityName),
    districtName,
    districtShortName: shortLocalName(districtName),
    industrySource,
    industryLabels: resolveIndustryLabels(industrySource),
    scopeRequired,
  };
}

export function templateMatchesRegion(file, region) {
  return scoreTemplateForRegion(file, region).visible;
}

export function templateMatchesIndustry(file, region) {
  if (!region?.industryLabels?.length) return true;
  const text = fileScopeText(file);
  const taggedIndustries = industryTermsInText(text);
  if (!taggedIndustries.length) return true;
  return industryMatches(taggedIndustries, region);
}

export function evaluateTemplateApplicability(file, region) {
  const source = sourceLayer(file);
  if (source) {
    return { visible: true, ...source };
  }

  // 先使用显式配置，缺少配置时才回退到文件名、子模块名和场景名的启发式识别。
  const structured = structuredEvaluation(file, region);
  if (structured) return structured;

  const businessMismatch = businessScopeMismatch(file, region);
  if (businessMismatch) return businessMismatch;

  const commercialMismatch = commercialExchangeMismatch(file, region);
  if (commercialMismatch) return commercialMismatch;

  const scopeText = fileScopeText(file);
  const titleText = fileTitleText(file);
  const national = nationalEvaluation(scopeText);
  let result = national || generalEvaluation(scopeText);

  if (region?.shortName || region?.scopeRequired) {
    const localSegments = unique([...localEditionSegments(scopeText), ...localNameSegments(titleText)]);
    if (localSegments.length) {
      const localRank = Math.max(...localSegments.map((segment) => segmentRegionRank(segment, region)));
      if (!localRank) return { visible: false, rank: 0, reason: "其他地区", layer: "hidden", badges: [] };
      if (localRank > result.rank) {
        result = {
          visible: true,
          rank: localRank,
          reason: regionReason(localRank),
          layer: regionLayer(localRank),
          badges: localSegments.filter((segment) => segmentRegionRank(segment, region)),
        };
      }
    } else {
      const taggedRegions = REGION_NAMES.filter((name) => scopeText.includes(name));
      if (taggedRegions.length) {
        const matchesCurrentProvince = taggedRegions.some(
          (name) => name === region.provinceName || name === region.provinceShortName,
        );
        if (!matchesCurrentProvince) {
          return { visible: false, rank: 0, reason: "其他地区", layer: "hidden", badges: [] };
        }
        const taggedRank = DIRECT_REGION_LABELS.includes(region.provinceName) ? 70 : 60;
        if (taggedRank > result.rank) {
          result = {
            visible: true,
            rank: taggedRank,
            reason: regionReason(taggedRank),
            layer: regionLayer(taggedRank),
            badges: taggedRegions,
          };
        }
      }
    }
  }

  if (region?.industryLabels?.length) {
    const taggedIndustries = industryTermsInText(scopeText);
    if (taggedIndustries.length) {
      const matchesIndustry = industryMatches(taggedIndustries, region);
      if (!matchesIndustry) return { visible: false, rank: 0, reason: "其他行业", layer: "hidden", badges: [] };
      if (result.rank < 40) {
        result = {
          visible: true,
          rank: 40,
          reason: "行业适用",
          layer: "industry",
          badges: taggedIndustries,
        };
      }
    }
  }

  return result;
}

export function scoreTemplateForRegion(file, region) {
  const { visible, rank, reason } = evaluateTemplateApplicability(file, region);
  return { visible, rank, reason };
}

function publicApplicabilityStatus(score) {
  return {
    reason: score.reason,
    layer: score.layer || "general",
    badges: score.badges || [],
    rank: score.rank,
  };
}

export function annotateTemplatesByApplicability(files, region, options = {}) {
  return files
    .map((file, index) => {
      const score = evaluateTemplateApplicability(file, region);
      return { file, index, score };
    })
    .filter(({ score }) => options.includeHidden || score.visible)
    .sort((first, second) => second.score.rank - first.score.rank || first.index - second.index)
    .map(({ file, score }) => ({
      ...file,
      applicabilityStatus: publicApplicabilityStatus(score),
    }));
}

export function filterTemplatesByRegion(files, region) {
  return annotateTemplatesByApplicability(files, region);
}

export function auditTemplateApplicability(files, region) {
  const initial = {
    total: files.length,
    visible: 0,
    hidden: 0,
    layers: {
      company: 0,
      personal: 0,
      district: 0,
      city: 0,
      province: 0,
      industry: 0,
      national: 0,
      general: 0,
    },
    hiddenReasons: {},
  };

  return files.reduce((audit, file) => {
    const score = evaluateTemplateApplicability(file, region);
    if (score.visible) {
      audit.visible += 1;
      const layer = score.layer || "general";
      audit.layers[layer] = (audit.layers[layer] || 0) + 1;
    } else {
      audit.hidden += 1;
      audit.hiddenReasons[score.reason] = (audit.hiddenReasons[score.reason] || 0) + 1;
    }
    return audit;
  }, initial);
}
